import { ActionsMenu } from '../../../../common/actions-menu/ActionsMenu';
import { FieldsDialogContentOptions } from '../../../../../constants/fieldsManagementConsts';
import { FieldOrigin } from '../../../../../types/enums/FieldOrigin';
import usePermission from '../../../../common/permissions/usePermission';
import { useState } from 'react';
import ManagePicklistDialog from './ManagePicklistDialog';
import { useDispatch } from 'react-redux';
import {
  createOrUpdateField,
  FieldUsageWithFieldMetadata,
  setDialogContent,
} from '../../../../../reducers/funnel-flow-page/fieldsReducer';
import { MoreActionsHorizontal } from '@sweep-io/sweep-design/dist/icons';
import { SfdcDisplayType } from '../../../../../types/fields';

const enum FieldActions {
  Manage = 'Manage',
  Edit = 'Edit',
}

const FieldsTableMenu = ({
  field,
  crmOrgId,
  isLeadingField,
  isRollup,
}: {
  field: FieldUsageWithFieldMetadata;
  crmOrgId: string;
  isLeadingField: boolean;
  isRollup: boolean;
}) => {
  const dispatch = useDispatch();
  const [isManagePicklistOpened, setIsManagePicklistOpened] = useState(false);

  const [isAllowedEditBtn] = usePermission(['edit:sweep-fields:update']);

  const {
    field: { origin, sfDisplayType },
  } = field;
  const actions = [];
  const addActions = !isRollup;
  if (addActions) {
    switch (origin) {
      case FieldOrigin.SF_CUSTOM:
      case FieldOrigin.SWEEP_CUSTOM:
        actions.push({
          label: FieldActions.Edit,
          value: FieldActions.Edit,
          disabled: !isAllowedEditBtn,
        });
        break;
      case FieldOrigin.SF_STANDARD:
        if (sfDisplayType === SfdcDisplayType.PICKLIST) {
          actions.push({
            label: FieldActions.Manage,
            value: FieldActions.Manage,
            disabled: !isAllowedEditBtn,
          });
        }
    }
  }

  return (
    <>
      <ActionsMenu
        actions={actions}
        onClick={(action) => {
          switch (action.value) {
            case FieldActions.Edit:
              dispatch(
                setDialogContent({
                  dialogContent: FieldsDialogContentOptions.EditField,
                  fieldToEdit: field,
                }),
              );
              break;
            case FieldActions.Manage:
              setIsManagePicklistOpened(true);
              break;
          }
        }}
        MenuButtonIcon={<MoreActionsHorizontal />}
        iconTooltip={
          !isAllowedEditBtn ? 'To modify the fields, please contact your admin.' : undefined
        }
      />
      <ManagePicklistDialog
        isOpened={isManagePicklistOpened}
        fieldToManage={field.field}
        crmOrgId={crmOrgId}
        isLeadingField={isLeadingField}
        closeDialog={() => setIsManagePicklistOpened(false)}
        onUpdateFieldCb={(field) => {
          dispatch(createOrUpdateField({ field }));
        }}
      />
    </>
  );
};

export default FieldsTableMenu;
